import { useMachine } from '@xstate/react'
import { requestMachine } from 'machines'
import { useCallback, useEffect, useRef } from 'react'
import { doesResourceExist } from 'videoReview/api/doesResourceExist'
import { getSignedURL } from 'videoReview/api/getSignedUrl'

export const useGetSignedUrl = (): [
  (id: string) => void,
  string | undefined,
  boolean,
  string
] => {
  const [urlState, urlSend] = useMachine(requestMachine)
  const [verifyState, verifySend] = useMachine(requestMachine)
  const videoId = useRef<string>()

  const get = useCallback(
    (id: string) => {
      videoId.current = id
      const promise = getSignedURL(id)
      urlSend('SET_PROMISE', { data: promise })
    },
    [urlSend]
  )
  const url = urlState.matches('success') && urlState.context.data
  useEffect(() => {
    if (url) {
      const promise = doesResourceExist(url)
      verifySend('SET_PROMISE', { data: promise })
    }
  }, [url, verifySend])

  const resourceExists = verifyState.matches('success')
    ? verifyState.context.data
    : verifyState.matches('failed')
    ? false
    : undefined

  const errorMessage = urlState.matches('failed')
    ? urlState.context.error
    : resourceExists === false
    ? "We couldn't find a video with the ID: " + videoId.current
    : ''

  const loading = urlState.matches('syncing') || resourceExists === undefined

  return [get, url, loading, errorMessage]
}
